import Repository from '../../repository';

export default {
	ChoseLanguage: (payload) => Repository.post(`/api/Guests/ChoseLanguage`, payload),
	GetInfoCmpnID: (payload) => Repository.post(`/api/Guests/GetInfoCmpnID`, payload),
	GetMenuRightByAppCode: (payload) => Repository.post(`/api/Guests/GetMenuRightByAppCode`, payload),
	GetRegionByGeoCode: (payload) => Repository.post(`/api/Guests/GetRegionByGeoCode`, payload),
};
